import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {GroupType} from 'src/app/models';

@Component({
    selector: 'app-group-edit',
    templateUrl: './group-type-popup.component.html',
    styleUrls: ['./group-type-popup.component.scss']
})
export class GroupTypePopupComponent {
    groupType: GroupType;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.groupType = new GroupType(this.data.group_type_id, this.data.ordinal, this.data.group_type, this.data.group_type_desc, this.data.use_system_global_intervals);
    }
}
